/**
 * Created by andrey on 26.03.2026
 */

class RateLimitTransport {
    constructor(options = {}) {
        options.limit = options.limit || 1000;
        this.options = options;

        this.data = new Map();
    }

    getKey(time) {
        return Math.floor(time / 1000 / 60);
    }

    shrink() {
        const time = this.getKey(Date.now() - 60 * 60 * 1000);

        for (const [key] of this.data) {
            if (key < time) {
                this.data.delete(key);
            }
        }
    }

    onRequest(amount = 1) {
        const key = this.getKey(Date.now());
        this.data.set(key, (this.data.get(key) || 0) + amount);
    }

    onRateLimit() {
        this.onRequest(Math.round(this.options.limit / 10));
    }

    countRequests(fromTime = 0) {
        const fromKey = this.getKey(fromTime);

        let result = 0;

        for (const [key, value] of this.data) {
            if (key >= fromKey) {
                result += value;
            }
        }

        return result;
    }

    canMakeRequests(requests = 1) {
        this.shrink();

        const sent = this.countRequests();

        if (requests + sent > this.options.limit) {
            return false;
        }

        const interval = 10;
        let limit = this.options.limit / 60 * interval;

        if (sent > this.options.limit * 0.75) {
            limit /= 4;
        } else if (sent > this.options.limit * 0.5) {
            limit /= 2;
        } else if (sent < this.options.limit * 0.25) {
            limit *= 2;
        }

        const intervalRequests = this.countRequests(Date.now() - 60 * 1000 * interval);

        return intervalRequests < limit;
    }
}
